function coerceText(value) {
  return value == null ? '' : String(value);
}

/** Map surviving {{n}} tokens to prior samples and renumber placeholders {{1}}..{{n}}. */
function remapPlaceholders(text, samples) {
  const safeText = coerceText(text);
  const safeSamples = Array.isArray(samples) ? samples : [];
  const tokenRegex = /\{\{(\d+)\}\}/g;
  const matches = [...safeText.matchAll(tokenRegex)];

  if (matches.length === 0) {
    return { text: safeText, samples: [] };
  }

  const newSamples = [];
  const replacements = [];
  let nextIndex = 1;

  matches.forEach(match => {
    const oldNum = parseInt(match[1], 10);
    const sampleIndex =
      Number.isFinite(oldNum) && oldNum > 0 ? oldNum - 1 : -1;
    newSamples.push(
      sampleIndex >= 0 && sampleIndex < safeSamples.length
        ? safeSamples[sampleIndex]
        : ''
    );
    const newToken = `{{${nextIndex}}}`;
    if (match[0] !== newToken) {
      replacements.push({
        start: match.index,
        end: match.index + match[0].length,
        newToken,
      });
    }
    nextIndex += 1;
  });

  let resultText = safeText;
  for (let i = replacements.length - 1; i >= 0; i -= 1) {
    const { start, end, newToken } = replacements[i];
    resultText = resultText.slice(0, start) + newToken + resultText.slice(end);
  }

  return { text: resultText, samples: newSamples };
}

export default {
  watch: {
    header(headerBody) {
      const safeHeader = coerceText(headerBody);
      if (
        safeHeader.trim().slice(-1) !== ' ' ||
        safeHeader.trim().slice(-1) !== '}'
      ) {
        this.restrictionHeader = false;
      }
      const { text: remappedHeader, samples: remappedSamples } =
        remapPlaceholders(safeHeader, this.header_text);
      const headercurrentCount = (
        remappedHeader.match(/{{\d+}}/g) || []
      ).length;
      if (headercurrentCount !== this.headerCount) {
        this.headerCount = headercurrentCount;
      }
      if (remappedHeader !== safeHeader) {
        this.header = remappedHeader;
        this.headerfinalBody = remappedHeader;
      }
      this.header_text = remappedSamples;
      this.previousHeaderCount = headercurrentCount;
      if (this.headerCount === 0) {
        this.showheader = false;
        this.header_text = [];
      } else if (this.headerCheck) {
        this.showheader = true;
      }
    },
    body(newBody) {
      const safeBody = coerceText(newBody);
      if (
        safeBody.trim().slice(-1) !== ' ' ||
        safeBody.trim().slice(-1) !== '}'
      ) {
        this.restrictionBody = false;
      }
      const { text: remappedBody, samples: remappedSamples } = remapPlaceholders(
        safeBody,
        this.body_text
      );
      const FilterArray = remappedBody.split(/\{\{\d+\}\}/g);
      const newFilterArray = FilterArray.filter(item => item.trim() !== '');
      const IncludeArray = remappedBody.split(' ');
      const variableCount = (remappedBody.match(/{{\d+}}/g) || []).length;
      if (variableCount !== this.clickCount) {
        this.clickCount = variableCount;
      }
      if (remappedBody !== safeBody) {
        this.body = remappedBody;
        this.finalbody = remappedBody;
      }
      this.body_text = remappedSamples;
      this.previousVariableCount = variableCount;
      if (this.clickCount === 0) {
        this.showmessage = false;
        this.messageVisible = false;
        this.body_text = [];
      } else {
        this.showmessage = true;
      }
      const containselement = IncludeArray.some(element =>
        /{{\d+}}/.test(element)
      );
      if (newFilterArray.length > 0 && containselement) {
        const wordCounts = newFilterArray.map(element => {
          const words = element.split(' ').filter(word => word.trim() !== '');
          return words.length;
        });
        const lastElement = IncludeArray[IncludeArray.length - 1].trim();
        if (/\{\{\d+\}\}/.test(lastElement)) {
          this.messageVisible = true;
        } else if (wordCounts[wordCounts.length - 1] >= 2) {
          this.messageVisible = false;
        }
      }
    },
    buttonOption(newOption) {
      if (newOption === 'none') {
        this.variableRelatedToActionButton = '';
        this.variableRelatedToQuickReply = '';
      }
    },
  },
  methods: {
    handleSubmit() {
      this.$v.$touch();
      this.onSubmit({
        format: this.format,
        header: this.header,
        header_text: this.header_text,
        body: this.body,
        body_text: this.body_text,
        file: this.file,
        fileName: this.fileName,
        footer: this.footer,
        buttonOption: this.buttonOption,
        buttonText: this.buttonText,
        buttonText1: this.buttonText1,
        websiteUrl: this.websiteUrl,
        dynamicInput: this.dynamicInput,
        phoneNumber: this.phoneNumber,
        navigationCards: this.navigationCards,
        replyButton: this.replyButton,
        clickCount: this.clickCount,
        finalbody: this.finalbody,
        hours: this.hours,
        minutes: this.minutes,
      });
      const blank = this.replyButtonValue;
      if (blank) {
        this.navigationCards.push({
          id: 'replyButton',
          label: 'Button text',
          value: blank,
        });
      }
    },

    addVariable() {
      this.showmessage = true;
      this.updateInputBox();
    },
    updateInputBox() {
      const variableCount = (this.body.match(/{{\d+}}/g) || []).length;
      this.clickCount = variableCount;

      if (this.clickCount >= 5) {
        return;
      }

      const editor = this.$refs.bodyEditor;
      let consecutiveBlocked = false;
      if (
        editor &&
        typeof editor.isNumericVariableInsertionRestricted === 'function'
      ) {
        consecutiveBlocked = editor.isNumericVariableInsertionRestricted();
      } else {
        const lastChar = coerceText(this.body).trim().slice(-1);
        consecutiveBlocked = lastChar === '}';
      }

      if (consecutiveBlocked) {
        this.restrictionBody = true;
        return;
      }

      const nextIndex = this.clickCount + 1;
      const token = `{{${nextIndex}}}`;

      if (editor && typeof editor.insertTextAtSelection === 'function') {
        const ok = editor.insertTextAtSelection(token);
        if (ok) {
          this.syncBodyFromEditor(editor);
          this.clickCount = nextIndex;
          this.restrictionBody = false;
          return;
        }
      }

      this.body = `${this.previousInputBoxData || this.body} {{${nextIndex}}}&nbsp;`;
      this.finalbody = this.body;
      this.clickCount = nextIndex;
      this.restrictionBody = false;
    },
    headerInputBox() {
      this.showheader = true;
      this.updateheaderBox();
    },
    updateheaderBox() {
      const headercurrentCount = (this.header.match(/{{\d+}}/g) || []).length;
      const lastChar = coerceText(this.header).trim().slice(-1);
      if (lastChar === ' ' || lastChar === '}') {
        this.restrictionHeader = true;
      } else if (this.headerCount < 1) {
        this.header += ' {{' + (headercurrentCount + 1) + '}} ';
        this.headerfinalBody = this.header;
        this.headerCount = headercurrentCount + 1;
        this.previousInputHeaderData = this.header;
      }
    },
    isInvalidUrl(url) {
      if (url === '') {
        return false;
      }
      const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
      return !urlPattern.test(url);
    },
    isInvalidPhoneNumber(phoneNumber) {
      if (phoneNumber === '') {
        return false;
      }
      const phonePattern = /^[0-9]{10}$/;
      return !phonePattern.test(phoneNumber);
    },
    addButtonVariable() {
      this.websiteUrl = this.dynamicEnabled ? '' : `${this.websiteUrl}{{}}`;
    },
    updateDynamicValue() {
      this.dynamicInput = this.dynamicEnabled
        ? this.dynamicValue
        : this.dynamicInput;
    },
    addNavigationCard() {
      this.navigationCards.push({
        id: 'card-' + (this.navigationCards.length + 1),
        label: 'Button text',
        value: '',
      });
    },
    validateCharacterLimit() {
      if (this.format === 'text') {
        if (this.header.length > this.maxCharacterLimit) {
          this.characterLimitError = 'Character limit exceeded';
          this.header = this.header.slice(0, this.maxCharacterLimit);
        } else {
          this.characterLimitError = '';
          this.previousInputHeaderData = this.header;
        }
      }
    },
    saveInputBoxData() {
      this.previousInputBoxData = this.body;
    },
    syncBodyFromEditor(editor) {
      const applyBody = () => {
        const updatedBody =
          editor && editor.contentFromEditor != null
            ? editor.contentFromEditor
            : this.body;
        this.body = updatedBody;
        this.finalbody = updatedBody;
        this.previousInputBoxData = updatedBody;
      };

      if (typeof this.$nextTick === 'function') {
        this.$nextTick(applyBody);
      } else {
        applyBody();
      }
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        const fileType = file.type;
        if (
          (this.format === 'image' && fileType.startsWith('image/')) ||
          (this.format === 'video' && fileType.startsWith('video/')) ||
          (this.format === 'document' && fileType === 'application/pdf')
        ) {
          this.url = URL.createObjectURL(file);
          this.file = this.url;
          this.fileName = file.name;
        } else {
          this.url = null;
          this.file = null;
          this.fileName = null;
        }
      }
    },
  },
};
